<template>
  <div id="admin-variant-character-group-list">
    <div id="card-container" v-if="loading || hasSearched" v-loading="loading">
      <div v-if="variantCharacterGroups.length">
        <el-card
          v-for="group in variantCharacterGroups"
          :key="group.id"
          class="character-group-card"
        >
          <div slot="header" class="clearfix">
            <span>{{ group.code }}</span>
            <el-button
              class="group-header-btn"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="showGroupDeleteDialog(group)"
            ></el-button>
            <el-button
              class="group-header-btn"
              type="primary"
              icon="el-icon-edit"
              circle
              @click="showGroupEditDialog(group)"
            ></el-button>
          </div>
          <div class="character-image-container">
            <el-link
              v-for="character in group.variantCharacters"
              :key="character.id"
              class="character-image-link"
            >
              <el-image
                class="character-image"
                :src="character._imageUrlForSrc"
                fit="cover"
                @click="showCharacterEditDialog(group, character)"
              >
              </el-image>
              <el-button
                type="danger"
                icon="el-icon-close"
                circle
                class="character-delete-btn"
                @click="showCharacterDeleteDialog(character)"
              ></el-button>
            </el-link>
            <el-button
              class="character-add-btn"
              icon="el-icon-plus"
              @click="showCharacterCreateDialog(group)"
            ></el-button>
          </div>
          <el-divider></el-divider>
          <span class="condition-label">検索用文字・部首</span>
          <el-divider
            direction="vertical"
            class="condition-divider"
          ></el-divider>
          <span
            v-for="condition in group.searchConditions"
            :key="condition"
            class="condition-tag"
          >
            {{ condition }}
          </span>
        </el-card>
      </div>
      <div v-else-if="hasSearched" id="no-character-groups">
        グループなし
      </div>
    </div>
    <div id="btn-container">
      <el-button
        icon="el-icon-plus"
        id="add-group-btn"
        @click="showGroupCreateDialog()"
        >グループを追加</el-button
      >
    </div>

    <!-- VariantCharacterGroup Create Dialog -->
    <el-dialog
      title="異体字グループの作成"
      :visible.sync="dialog.variantCharacterGroupCreate.visible"
      width="60%"
    >
      <el-form label-width="150px">
        <el-form-item label="書体">
          <el-select v-model="params.variantCharacterGroupCreate.input.font">
            <el-option value="手彫り風書体">手彫り風書体</el-option>
            <el-option value="標準書体">楷書体</el-option>
            <el-option value="合掌体">機械書</el-option>
            <el-option value="手書き">手書き</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="グループコード">
          <el-input
            v-model="params.variantCharacterGroupCreate.input.code"
          ></el-input>
        </el-form-item>
        <el-form-item label="検索用文字・部首">
          <el-input
            class="search-character-input"
            v-model="
              params.variantCharacterGroupCreate.input.searchConditions[0]
            "
            type="text"
          ></el-input>
          <el-input
            class="search-character-input"
            v-model="
              params.variantCharacterGroupCreate.input.searchConditions[1]
            "
            type="text"
          ></el-input>
          <el-input
            class="search-character-input"
            v-model="
              params.variantCharacterGroupCreate.input.searchConditions[2]
            "
            type="text"
          ></el-input>
          <el-input
            class="search-character-input"
            v-model="
              params.variantCharacterGroupCreate.input.searchConditions[3]
            "
            type="text"
          ></el-input>
          <el-input
            class="search-character-input"
            v-model="
              params.variantCharacterGroupCreate.input.searchConditions[4]
            "
            type="text"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.variantCharacterGroupCreate.visible = false"
          >キャンセル</el-button
        >
        <el-button
          type="primary"
          @click="
            createVariantCharacterGroup(params.variantCharacterGroupCreate)
          "
          :loading="dialog.variantCharacterGroupCreate.loading"
          >作成</el-button
        >
      </span>
    </el-dialog>

    <!-- VariantCharacterGroup Edit Dialog -->
    <el-dialog
      title="異体字グループの更新"
      :visible.sync="dialog.variantCharacterGroupEdit.visible"
      width="60%"
    >
      <el-form label-width="150px">
        <el-form-item label="書体">
          <el-select
            v-model="params.variantCharacterGroupEdit.input.font"
            disabled
          >
            <el-option value="手彫り風書体">手彫り風書体</el-option>
            <el-option value="標準書体">楷書体</el-option>
            <el-option value="合掌体">機械書</el-option>
            <el-option value="手書き">手書き</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="グループコード">
          <el-input
            v-model="params.variantCharacterGroupEdit.input.code"
          ></el-input>
        </el-form-item>
        <el-form-item label="検索用文字・部首">
          <el-input
            class="search-character-input"
            v-model="params.variantCharacterGroupEdit.input.searchConditions[0]"
            type="text"
          ></el-input>
          <el-input
            class="search-character-input"
            v-model="params.variantCharacterGroupEdit.input.searchConditions[1]"
            type="text"
          ></el-input>
          <el-input
            class="search-character-input"
            v-model="params.variantCharacterGroupEdit.input.searchConditions[2]"
            type="text"
          ></el-input>
          <el-input
            class="search-character-input"
            v-model="params.variantCharacterGroupEdit.input.searchConditions[3]"
            type="text"
          ></el-input>
          <el-input
            class="search-character-input"
            v-model="params.variantCharacterGroupEdit.input.searchConditions[4]"
            type="text"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.variantCharacterGroupEdit.visible = false"
          >キャンセル</el-button
        >
        <el-button
          type="primary"
          @click="updateVariantCharacterGroup(params.variantCharacterGroupEdit)"
          :loading="dialog.variantCharacterGroupEdit.loading"
          >更新</el-button
        >
      </span>
    </el-dialog>

    <!-- VariantCharacterGroup Delete Dialog -->
    <el-dialog
      title="警告"
      :visible.sync="dialog.variantCharacterGroupDelete.visible"
      width="40%"
      class="delete-dialog"
    >
      <span
        >グループ
        {{ dialog.variantCharacterGroupDelete.group.code }}
        を削除しますか？</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.variantCharacterGroupDelete.visible = false"
          >キャンセル</el-button
        >
        <el-button
          type="danger"
          @click="
            deleteVariantCharacterGroup(params.variantCharacterGroupDelete)
          "
          :loading="dialog.variantCharacterGroupDelete.loading"
          >削除</el-button
        >
      </span>
    </el-dialog>

    <!-- VariantCharacter Create Dialog -->
    <el-dialog
      title="異体字の作成"
      :visible.sync="dialog.variantCharacterCreate.visible"
      width="60%"
    >
      <el-form label-width="150px">
        <el-form-item label="異体字画像（黒）">
          <el-upload
            class="character-image-uploader"
            ref="createImageUploader"
            action=""
            accept=".jpg, .png"
            :multiple="false"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="onChangeVariantCharacterImageForCreate"
            :on-remove="onRemoveVariantCharacterImageForCreate"
          >
            <el-image
              v-if="dialog.variantCharacterCreate.thumbnailUrl"
              :src="dialog.variantCharacterCreate.thumbnailUrl"
              class="selected-character-image"
              fit="cover"
            />
            <i v-else class="el-icon-plus character-image-uploader-icon"></i>
            <div class="el-upload__tip" slot="tip">
              jpgまたはpngファイル、1MB以内
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="異体字画像（白）">
          <el-upload
            class="character-image-uploader"
            ref="createImageForTabletUploader"
            action=""
            accept=".jpg, .png"
            :multiple="false"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="onChangeVariantCharacterImageForTabletForCreate"
            :on-remove="onRemoveVariantCharacterImageForTabletForCreate"
          >
            <el-image
              v-if="dialog.variantCharacterCreate.thumbnailUrlForTablet"
              :src="dialog.variantCharacterCreate.thumbnailUrlForTablet"
              class="selected-character-image"
              fit="cover"
            />
            <i v-else class="el-icon-plus character-image-uploader-icon"></i>
            <div class="el-upload__tip" slot="tip">
              jpgまたはpngファイル、1MB以内
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="管理コード1">
          <el-input
            v-model="params.variantCharacterCreate.input.managementCode1"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理コード2">
          <el-input
            v-model="params.variantCharacterCreate.input.managementCode2"
          ></el-input>
        </el-form-item>
        <el-form-item label="彫機入力用コード">
          <el-input
            v-model="params.variantCharacterCreate.input.inputCode"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.variantCharacterCreate.visible = false"
          >キャンセル</el-button
        >
        <el-button
          type="primary"
          @click="createVariantCharacter(params.variantCharacterCreate)"
          :loading="dialog.variantCharacterCreate.loading"
          >作成</el-button
        >
      </span>
    </el-dialog>

    <!-- VariantCharacter Edit Dialog -->
    <el-dialog
      title="異体字の更新"
      :visible.sync="dialog.variantCharacterEdit.visible"
      width="60%"
    >
      <el-form label-width="150px">
        <el-form-item label="異体字画像（黒）">
          <el-upload
            class="character-image-uploader"
            ref="editImageUploader"
            action=""
            accept=".jpg, .png"
            :multiple="false"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="onChangeVariantCharacterImageForEdit"
            :on-remove="onRemoveVariantCharacterImageForEdit"
          >
            <el-image
              v-if="dialog.variantCharacterEdit.thumbnailUrl"
              :src="dialog.variantCharacterEdit.thumbnailUrl"
              class="selected-character-image"
              fit="cover"
            />
            <i v-else class="el-icon-plus character-image-uploader-icon"></i>
            <div class="el-upload__tip" slot="tip">
              jpgまたはpngファイル、1MB以内
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="異体字画像（白）">
          <el-upload
            class="character-image-uploader"
            ref="editImageForTabletUploader"
            action=""
            accept=".jpg, .png"
            :multiple="false"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="onChangeVariantCharacterImageForTabletForEdit"
            :on-remove="onRemoveVariantCharacterImageForTabletForEdit"
          >
            <el-image
              v-if="dialog.variantCharacterEdit.thumbnailUrlForTablet"
              :src="dialog.variantCharacterEdit.thumbnailUrlForTablet"
              class="selected-character-image"
              fit="cover"
            />
            <i v-else class="el-icon-plus character-image-uploader-icon"></i>
            <div class="el-upload__tip" slot="tip">
              jpgまたはpngファイル、1MB以内
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="管理コード1">
          <el-input
            v-model="params.variantCharacterEdit.input.managementCode1"
          ></el-input>
        </el-form-item>
        <el-form-item label="管理コード2">
          <el-input
            v-model="params.variantCharacterEdit.input.managementCode2"
          ></el-input>
        </el-form-item>
        <el-form-item label="彫機入力用コード">
          <el-input
            v-model="params.variantCharacterEdit.input.inputCode"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.variantCharacterEdit.visible = false"
          >キャンセル</el-button
        >
        <el-button
          type="primary"
          @click="updateVariantCharacter(params.variantCharacterEdit)"
          :loading="dialog.variantCharacterEdit.loading"
          >更新</el-button
        >
      </span>
    </el-dialog>

    <!-- VariantCharacter Delete Dialog -->
    <el-dialog
      title="警告"
      :visible.sync="dialog.variantCharacterDelete.visible"
      width="40%"
      class="delete-dialog"
    >
      <div class="delete-character-image-wrapper">
        <el-image
          :src="dialog.variantCharacterDelete.thumbnailUrl"
          class="delete-character-image"
          fit="cover"
        />
        <el-image
          :src="dialog.variantCharacterDelete.thumbnailUrlForTablet"
          class="delete-character-image"
          fit="cover"
        />
      </div>
      <span>この異体字を削除しますか？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.variantCharacterDelete.visible = false"
          >キャンセル</el-button
        >
        <el-button
          type="danger"
          @click="deleteVariantCharacter(params.variantCharacterDelete)"
          :loading="dialog.variantCharacterDelete.loading"
          >削除</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UsecaseFactory from "@/usecases/usecase.factory.js";
import FileUsecase from "@/usecases/file.usecase";

const variantCharacterGroupUsecase = UsecaseFactory.create("variantCharacterGroup");
const variantCharacterUsecase = UsecaseFactory.create("variantCharacter");

export default {
  data () {
    return {
      // 異体字グループリスト
      variantCharacterGroups: [],

      // ダイアログ制御
      dialog: {
        variantCharacterGroupCreate: {
          visible: false,
          loading: false,
        },
        variantCharacterGroupEdit: {
          visible: false,
          loading: false,
        },
        variantCharacterGroupDelete: {
          visible: false,
          loading: false,
          group: {
            code: "",
          },
        },
        variantCharacterCreate: {
          visible: false,
          loading: false,
          thumbnailUrl: "",
          thumbnailUrlForTablet: "",
        },
        variantCharacterEdit: {
          visible: false,
          loading: false,
          thumbnailUrl: "",
          thumbnailUrlForTablet: "",
        },
        variantCharacterDelete: {
          visible: false,
          loading: false,
          thumbnailUrl: "",
          thumbnailUrlForTablet: "",
        },
      },

      // 作成・更新・削除パラメータ
      params: {
        variantCharacterGroupCreate: {
          input: {
            font: "",
            code: "",
            searchConditions: [],
          },
        },
        variantCharacterGroupEdit: {
          id: "",
          input: {
            font: "",
            code: "",
            searchConditions: [],
          },
        },
        variantCharacterGroupDelete: {
          id: "",
        },
        variantCharacterCreate: {
          input: {
            variantCharacterGroupId: "",
            imageUrl: "", // 実際にはURLではなくファイル名を入れて利用している
            imageUrlForTablet: "", // 実際にはURLではなくファイル名を入れて利用している
            managementCode1: "",
            managementCode2: "",
            inputCode: "",
          },
        },
        variantCharacterEdit: {
          id: "",
          input: {
            variantCharacterGroupId: "",
            imageUrl: "", // 実際にはURLではなくファイル名を入れて利用している
            imageUrlForTablet: "", // 実際にはURLではなくファイル名を入れて利用している
            managementCode1: "",
            managementCode2: "",
            inputCode: "",
          },
        },
        variantCharacterDelete: {
          id: "",
        },
      },

      // 表示制御
      font: "手彫り風書体",
      hasSearched: false,
      loading: false,
    };
  },
  watch: {
    variantCharacterGroups: async function (variantCharacterGroups) {
      const promises = [];
      variantCharacterGroups.forEach(group => {
        if (group.variantCharacters) {
          group.variantCharacters.forEach(character => {
            // ファイル名のみ登録している場合、画像URLに変換する
            if (character.imageUrl && !character.imageUrl.match(/^http/)) {
              const promise = Promise.all([
                usecase.file.fetchURL(character.imageUrl).then(url => {
                  character._imageUrlForSrc = url;
                }),
                usecase.file.fetchURL(character.imageUrlForTablet).then(url => {
                  character._imageUrlForTabletForSrc = url;
                }),
              ]);
              promises.push(promise);
            }
          });
        }
      });
      await Promise.all(promises);
    },
  },
  methods: {
    /************************************************************
     * Query / Mutation
     ************************************************************/

    /**
     * @param {object} options
     */
    async getVariantCharacterGroupsByFilterConditions (options) {
      this.font = options.q.font;
      this.loading = true;

      // グループの取得
      let variantCharacterGroups;
      try {
        variantCharacterGroups = await variantCharacterGroupUsecase.getVariantCharacterGroups(
          options
        );
      } catch (err) {
        this.loading = false;
        /*
        console.log(err);
        this.$notify.error({
          title: "エラー",
          message: "異体字グループの検索に失敗しました。"
        });
         */
        return;
      }

      // 異体字画像のURLにはファイル名のみが登録されているため、S3から取得できるURLを専用のキーへ保存する
      const promises = [];
      variantCharacterGroups.forEach(group => {
        if (group.variantCharacters) {
          group.variantCharacters.forEach(character => {
            const promise = this.setImageUrlForSrc(character);
            promises.push(promise);
          });
        }
      });
      try {
        await Promise.all(promises);
      } catch (err) {
        this.loading = false;
        console.log(err);
        this.$notify.error({
          title: "エラー",
          message: "異体字画像URLの取得に失敗しました。",
        });
        return;
      }

      this.variantCharacterGroups = variantCharacterGroups;
      this.loading = false;
      this.hasSearched = true;
    },

    /**
     * @param {object} params
     */
    async createVariantCharacterGroup (params) {
      // 検索用文字・部首はバラバラに入力されるため、未入力や空文字などを弾く
      params.input.searchConditions = params.input.searchConditions.filter(
        condition => {
          return (
            condition !== undefined && condition !== null && condition !== ""
          );
        }
      );

      this.dialog.variantCharacterGroupCreate.loading = true;

      // 異体字グループを作成
      let variantCharacterGroup;
      try {
        variantCharacterGroup = await variantCharacterGroupUsecase.createVariantCharacterGroup(
          params
        );
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: "エラー",
          message: "異体字グループの作成に失敗しました。",
        });
        return;
      } finally {
        this.dialog.variantCharacterGroupCreate.loading = false;
      }

      // リストへ追加
      this.variantCharacterGroups.push(variantCharacterGroup);

      // 作成パラメータをリセット
      this.resetGroupCreateParams();

      // ダイアログを閉じる
      this.dialog.variantCharacterGroupCreate.visible = false;
    },

    /**
     * @param {object} params
     */
    async updateVariantCharacterGroup (params) {
      // 検索用文字・部首はバラバラに入力されるため、未入力や空文字などを弾く
      params.input.searchConditions = params.input.searchConditions.filter(
        condition => {
          return (
            condition !== undefined && condition !== null && condition !== ""
          );
        }
      );

      this.dialog.variantCharacterGroupEdit.loading = true;

      // 異体字グループを更新
      let updatedVariantCharacterGroup;
      try {
        updatedVariantCharacterGroup = await variantCharacterGroupUsecase.updateVariantCharacterGroup(
          params
        );
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: "エラー",
          message: "異体字グループの更新に失敗しました。",
        });
        return;
      } finally {
        this.dialog.variantCharacterGroupEdit.loading = false;
      }

      // リストを更新
      const group = this.variantCharacterGroups.find(group => {
        return group.id === updatedVariantCharacterGroup.id;
      });
      if (group) {
        group.font = updatedVariantCharacterGroup.font;
        group.code = updatedVariantCharacterGroup.code;
        group.searchConditions = updatedVariantCharacterGroup.searchConditions;
      }

      // 更新パラメータをリセット
      this.resetGroupEditParams();

      // ダイアログを閉じる
      this.dialog.variantCharacterGroupEdit.visible = false;
    },

    /**
     * @param {object} params
     */
    async deleteVariantCharacterGroup (params) {
      this.dialog.variantCharacterGroupDelete.loading = true;

      // 異体字グループを更新
      let deletedVariantCharacterGroup;
      try {
        deletedVariantCharacterGroup = await variantCharacterGroupUsecase.deleteVariantCharacterGroup(
          params
        );
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: "エラー",
          message: "異体字グループの削除に失敗しました。",
        });
        return;
      } finally {
        this.dialog.variantCharacterGroupDelete.loading = false;
      }

      // リストを更新
      this.variantCharacterGroups = this.variantCharacterGroups.filter(
        group => {
          return group.id !== deletedVariantCharacterGroup.id;
        }
      );

      // 更新パラメータをリセット
      this.resetGroupDeleteParams();

      // ダイアログを閉じる
      this.dialog.variantCharacterGroupDelete.group = {
        code: "",
      };
      this.dialog.variantCharacterGroupDelete.visible = false;
    },

    /**
     * @param {object} params
     */
    async createVariantCharacter (params) {
      // 画像の指定を強制する
      if (!params.input.imageUrl || params.input.imageUrl === "") {
        this.$notify.error({
          title: "エラー",
          message: "異体字画像（黒）が選択されていません。",
        });
        return;
      }
      if (
        !params.input.imageUrlForTablet ||
        params.input.imageUrlForTablet === ""
      ) {
        this.$notify.error({
          title: "エラー",
          message: "異体字画像（白）が選択されていません。",
        });
        return;
      }

      this.dialog.variantCharacterCreate.loading = true;

      // 異体字を作成
      let variantCharacter;
      try {
        variantCharacter = await variantCharacterUsecase.createVariantCharacter(
          params
        );
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: "エラー",
          message: "異体字の作成に失敗しました。",
        });
        return;
      } finally {
        this.dialog.variantCharacterCreate.loading = false;
      }

      // 表示用のURLを設定
      try {
        await this.setImageUrlForSrc(variantCharacter);
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: "エラー",
          message: "異体字画像URLの取得に失敗しました。",
        });
        return;
      }

      // グループへ追加
      const group = this.variantCharacterGroups.find(group => {
        return group.id === params.input.variantCharacterGroupId;
      });
      if (group && Array.isArray(group.variantCharacters)) {
        group.variantCharacters.push(variantCharacter);
      }

      // 作成パラメータをリセット
      this.resetCharacterCreateParams();

      // 画像アップローダーをリセット
      this.$refs.createImageUploader.clearFiles();
      this.dialog.variantCharacterCreate.thumbnailUrl = "";

      // ダイアログを閉じる
      this.dialog.variantCharacterCreate.visible = false;
    },

    /**
     * @param {object} params
     */
    async updateVariantCharacter (params) {
      // 画像の指定を強制する
      if (!params.input.imageUrl || params.input.imageUrl === "") {
        this.$notify.error({
          title: "エラー",
          message: "異体字画像（黒）が選択されていません。",
        });
        return;
      }
      if (
        !params.input.imageUrlForTablet ||
        params.input.imageUrlForTablet === ""
      ) {
        this.$notify.error({
          title: "エラー",
          message: "異体字画像（白）が選択されていません。",
        });
        return;
      }

      this.dialog.variantCharacterEdit.loading = true;

      // 異体字を更新
      let updatedVariantCharacter;
      try {
        updatedVariantCharacter = await variantCharacterUsecase.updateVariantCharacter(
          params
        );
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: "エラー",
          message: "異体字の更新に失敗しました。",
        });
        return;
      } finally {
        this.dialog.variantCharacterEdit.loading = false;
      }

      // 表示用のURLを設定
      try {
        await this.setImageUrlForSrc(updatedVariantCharacter);
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: "エラー",
          message: "異体字画像URLの取得に失敗しました。",
        });
        return;
      }

      // パラメータを更新
      const group = this.variantCharacterGroups.find(group => {
        return group.id === params.input.variantCharacterGroupId;
      });
      const character = group.variantCharacters.find(character => {
        return character.id === params.id;
      });
      if (character) {
        character.imageUrl = updatedVariantCharacter.imageUrl;
        character.imageUrlForTablet = updatedVariantCharacter.imageUrlForTablet;
        character.managementCode1 = updatedVariantCharacter.managementCode1;
        character.managementCode2 = updatedVariantCharacter.managementCode2;
        character.inputCode = updatedVariantCharacter.inputCode;
        await this.setImageUrlForSrc(character);
      }

      // 更新パラメータをリセット
      this.resetCharacterEditParams();

      // 画像アップローダーをリセット
      this.$refs.editImageUploader.clearFiles();
      this.$refs.editImageForTabletUploader.clearFiles();
      this.dialog.variantCharacterEdit.thumbnailUrl = "";
      this.dialog.variantCharacterEdit.thumbnailUrlForTablet = "";

      // ダイアログを閉じる
      this.dialog.variantCharacterEdit.visible = false;
    },

    /**
     * @param {object} params
     */
    async deleteVariantCharacter (params) {
      this.dialog.variantCharacterDelete.loading = true;

      // 異体字を削除
      let deletedVariantCharacter;
      try {
        deletedVariantCharacter = await variantCharacterUsecase.deleteVariantCharacter(
          params
        );
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: "エラー",
          message: "異体字の削除に失敗しました。",
        });
        return;
      } finally {
        this.dialog.variantCharacterDelete.loading = false;
      }

      // 削除した異体字をリストから除外
      this.variantCharacterGroups.forEach(group => {
        group.variantCharacters = group.variantCharacters.filter(character => {
          return character.id !== deletedVariantCharacter.id;
        });
      });

      // 削除パラメータをリセット
      this.resetCharacterDeleteParams();

      // ダイアログを閉じる
      this.dialog.variantCharacterDelete.thumbnailUrl = "";
      this.dialog.variantCharacterDelete.visible = false;
    },

    /************************************************************
     * Event Handler
     ************************************************************/

    showGroupCreateDialog () {
      this.params.variantCharacterGroupCreate.input.font = this.font;
      this.dialog.variantCharacterGroupCreate.visible = true;
    },

    /**
     * @param {VariantCharacterGroup} group
     */
    showGroupEditDialog (group) {
      this.params.variantCharacterGroupEdit = {
        id: group.id,
        input: {
          font: group.font,
          code: group.code,
          searchConditions: [...group.searchConditions],
        },
      };
      this.dialog.variantCharacterGroupEdit.visible = true;
    },

    /**
     * @param {VariantCharacterGroup} group
     */
    showGroupDeleteDialog (group) {
      this.params.variantCharacterGroupDelete.id = group.id;
      this.dialog.variantCharacterGroupDelete.group = group;
      this.dialog.variantCharacterGroupDelete.visible = true;
    },

    /**
     * @param {VariantCharacterGroup} group
     */
    showCharacterCreateDialog (group) {
      this.params.variantCharacterCreate.input.variantCharacterGroupId =
        group.id;
      this.dialog.variantCharacterCreate.visible = true;
    },

    /**
     * @param {VariantCharacterGroup} group
     * @param {VariantCharacter} character
     */
    showCharacterEditDialog (group, character) {
      this.params.variantCharacterEdit = {
        id: character.id,
        input: {
          variantCharacterGroupId: group.id,
          imageUrl: character.imageUrl,
          imageUrlForTablet: character.imageUrlForTablet,
          managementCode1: character.managementCode1,
          managementCode2: character.managementCode2,
          inputCode: character.inputCode,
        },
      };
      this.dialog.variantCharacterEdit.thumbnailUrl = character._imageUrlForSrc;
      this.dialog.variantCharacterEdit.thumbnailUrlForTablet =
        character._imageUrlForTabletForSrc;
      this.dialog.variantCharacterEdit.visible = true;
    },

    /**
     * @param {VariantCharacter} character
     */
    showCharacterDeleteDialog (character) {
      this.params.variantCharacterDelete.id = character.id;
      this.dialog.variantCharacterDelete.thumbnailUrl =
        character._imageUrlForSrc;
      this.dialog.variantCharacterDelete.thumbnailUrlForTablet =
        character._imageUrlForTabletForSrc;
      this.dialog.variantCharacterDelete.visible = true;
    },

    /**
     * @param {object} file
     */
    async onChangeVariantCharacterImageForCreate (file) {
      // アップロード時のファイルサイズ制限
      // small: 1MB まで
      if (!usecase.file.validateFileSize(file, "small")) {
        this.$refs.createImageUploader.clearFiles();

        return;
      }

      // S3へアップロード
      try {
        const result = await this.uploadToS3(file);

        // 作成パラメータへ反映
        this.params.variantCharacterCreate.input.imageUrl = result.key;

        // サムネイル表示
        this.dialog.variantCharacterCreate.thumbnailUrl = URL.createObjectURL(file.raw);
      } catch (err) {
        console.log(err);

        this.$refs.createImageUploader.clearFiles();
      }
    },

    /**
     * @param {object} file
     */
    async onChangeVariantCharacterImageForTabletForCreate (file) {
      // アップロード時のファイルサイズ制限
      // small: 1MB まで
      if (!usecase.file.validateFileSize(file, "small")) {
        this.$refs.createImageForTabletUploader.clearFiles();

        return;
      }

      // S3へアップロード
      try {
        const result = await this.uploadToS3(file);

        // 作成パラメータへ反映
        this.params.variantCharacterCreate.input.imageUrlForTablet = result.key;

        // サムネイル表示
        this.dialog.variantCharacterCreate.thumbnailUrlForTablet = URL.createObjectURL(file.raw);
      } catch (err) {
        console.log(err);

        this.$refs.createImageForTabletUploader.clearFiles();
      }
    },

    /**
     * @param {object} file
     */
    async onChangeVariantCharacterImageForEdit (file) {
      // アップロード時のファイルサイズ制限
      // small: 1MB まで
      if (!usecase.file.validateFileSize(file, "small")) {
        this.$refs.editImageUploader.clearFiles();

        return;
      }

      // S3へアップロード
      try {
        const result = await this.uploadToS3(file);

        // 更新パラメータへ反映
        this.params.variantCharacterEdit.input.imageUrl = result.key;

        // サムネイル表示
        this.dialog.variantCharacterEdit.thumbnailUrl = URL.createObjectURL(file.raw);
      } catch (err) {
        console.log(err);

        this.$refs.editImageUploader.clearFiles();
      }
    },

    /**
     * @param {object} file
     */
    async onChangeVariantCharacterImageForTabletForEdit (file) {
      // アップロード時のファイルサイズ制限
      // small: 1MB まで
      if (!usecase.file.validateFileSize(file, "small")) {
        this.$refs.editImageForTabletUploader.clearFiles();

        return;
      }

      // S3へアップロード
      try {
        const result = await this.uploadToS3(file);

        // 更新パラメータへ反映
        this.params.variantCharacterEdit.input.imageUrlForTablet = result.key;

        // サムネイル表示
        this.dialog.variantCharacterEdit.thumbnailUrlForTablet = URL.createObjectURL(file.raw);
      } catch (err) {
        console.log(err);

        this.$refs.editImageForTabletUploader.clearFiles();
      }
    },

    onRemoveVariantCharacterImageForCreate () {
      this.params.variantCharacterCreate.input.imageUrl = "";
      this.dialog.variantCharacterCreate.thumbnailUrl = "";
    },

    onRemoveVariantCharacterImageForTabletForCreate () {
      this.params.variantCharacterCreate.input.imageUrlForTablet = "";
      this.dialog.variantCharacterCreate.thumbnailUrlForTablet = "";
    },

    onRemoveVariantCharacterImageForEdit () {
      this.params.variantCharacterEdit.input.imageUrl = "";
      this.dialog.variantCharacterEdit.thumbnailUrl = "";
    },

    onRemoveVariantCharacterImageForTabletForEdit () {
      this.params.variantCharacterEdit.input.imageUrlForTablet = "";
      this.dialog.variantCharacterEdit.thumbnailUrlForTablet = "";
    },

    /************************************************************
     * Util
     ************************************************************/

    /**
     * @param {object} file
     */
    async uploadToS3 (file) {
      const {
        name,
        raw,
      } = file;

      // 保存する画像のカテゴリを分ける
      const category = "itaiji";

      const fileName = usecase.file.fetchFileName(name, category);

      return usecase.file.uploadFile(fileName, raw);
    },

    /**
     * VariantCharacterに表示用のURL（VariantCharacter._imageUrlForSrc/_imageUrlForTabletForSrc）を追加
     * ※ 副作用として、引数:variantCharacterに以下のパラメータが追加されます。
     *     variantCharacter._imageUrlForSrc {string}
     *     variantCharacter._imageUrlForTabletForSrc {string}
     * @param {VariantCharacter} variantCharacter
     */
    async setImageUrlForSrc (variantCharacter) {
      // imageUrl
      const imageUrlPromise = new Promise(resolve => {
        if (!variantCharacter.imageUrl) {
          return resolve();
        }

        // 元からURLで登録されている場合、元の値を利用する
        if (variantCharacter.imageUrl.match(/^http/)) {
          variantCharacter._imageUrlForSrc = variantCharacter.imageUrl;
          return resolve();
        }

        // ファイル名のみ登録されている場合、画像URLに変換する
        usecase.file.fetchURL(variantCharacter.imageUrl).then(url => {
          variantCharacter._imageUrlForSrc = url;
          resolve();
        });
      });

      // imageUrlForTablet
      const imageUrlForTabletPromise = new Promise(resolve => {
        if (!variantCharacter.imageUrlForTablet) {
          return resolve();
        }

        // 元からURLで登録されている場合、元の値を利用する
        if (variantCharacter.imageUrlForTablet.match(/^http/)) {
          variantCharacter._imageUrlForTabletForSrc =
            variantCharacter.imageUrlForTablet;
          return resolve();
        }

        // ファイル名のみ登録されている場合、画像URLに変換する
        usecase.file.fetchURL(variantCharacter.imageUrlForTablet).then(url => {
          variantCharacter._imageUrlForTabletForSrc = url;
          resolve();
        });
      });

      return Promise.all([imageUrlPromise, imageUrlForTabletPromise]);
    },

    resetGroupCreateParams () {
      this.params.variantCharacterGroupCreate = {
        input: {
          font: "",
          code: "",
          searchConditions: [],
        },
      };
    },

    resetGroupEditParams () {
      this.params.variantCharacterGroupEdit = {
        id: "",
        input: {
          font: "",
          code: "",
          searchConditions: [],
        },
      };
    },

    resetGroupDeleteParams () {
      this.params.variantCharacterGroupDelete = {
        id: "",
      };
    },

    resetCharacterCreateParams () {
      this.params.variantCharacterCreate = {
        input: {
          variantCharacterGroupId: "",
          imageUrl: "",
          managementCode1: "",
          managementCode2: "",
          inputCode: "",
        },
      };
    },

    resetCharacterEditParams () {
      this.params.variantCharacterEdit = {
        id: "",
        input: {
          variantCharacterGroupId: "",
          imageUrl: "",
          managementCode1: "",
          managementCode2: "",
          inputCode: "",
        },
      };
    },

    resetCharacterDeleteParams () {
      this.params.variantCharacterDelete = {
        id: "",
      };
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>

<style lang="scss">
@import "~@/assets/styles/variables.scss";
/**
 * card list
 */
#admin-variant-character-group-list #card-container {
  min-height: 68px;
}
#admin-variant-character-group-list #card-container,
#admin-variant-character-group-list #btn-container {
  padding: 22px 20px;
}
#admin-variant-character-group-list #card-container + #btn-container {
  padding-top: 0px;
}
#admin-variant-character-group-list #no-character-groups {
  padding: 22px 20px;
  text-align: center;
  color: $text-extra-light; // #909399;
}
#admin-variant-character-group-list #add-group-btn {
  width: 100%;
  height: 50px;
}

/**
 * card
 */
#admin-variant-character-group-list .character-group-card {
  margin-bottom: 22px;
}
#admin-variant-character-group-list .character-group-card:last-child {
  margin-bottom: 0;
}

/**
 * card header
 */
.character-group-card .group-header-btn {
  float: right;
  margin-top: -0.5rem;
}
.character-group-card .group-header-btn + .group-header-btn {
  margin-right: 10px;
}

/**
 * card body
 */
#admin-variant-character-group-list .character-image-link,
#admin-variant-character-group-list .character-add-btn {
  margin-right: 5px;
  margin-bottom: 5px;
}
#admin-variant-character-group-list .character-image,
#admin-variant-character-group-list .character-add-btn {
  width: 80px;
  height: 80px;
}
#admin-variant-character-group-list .character-image {
  border: 1px solid $--border-color-light;
  box-sizing: border-box;
  border-radius: 4px;
  background: black;
}
#admin-variant-character-group-list .character-add-btn {
  vertical-align: top;
}
#admin-variant-character-group-list
  .character-image-link
  .character-delete-btn {
  display: none;
  padding: 5px;
  position: absolute;
  top: -10px;
  right: -10px;
  z-index: 100;
}
#admin-variant-character-group-list
  .character-image-link:hover
  .character-delete-btn {
  display: block;
}

/**
 * card footer
 */
.character-group-card .el-divider--horizontal {
  margin: 9px 0 15px 0;
}
.character-group-card .condition-label {
  vertical-align: middle;
  line-height: 40px;
  font-size: 14px;
  color: $text-lighter;
}
.character-group-card .condition-divider {
  height: 40px;
  vertical-align: middle;
}
.character-group-card .condition-tag {
  display: inline-block;
  vertical-align: middle;
  width: 40px;
  line-height: 40px;
  text-align: center;
  background: none;
  border: 1px solid $--border-color-light;
  border-radius: 4px;
  font-size: 16px;
  color: $text-light;
}
.character-group-card .condition-tag + .condition-tag {
  margin-left: 5px;
}

/**
 * create/update dialog
 */
.character-image-uploader .el-upload__tip {
  line-height: 12px;
  margin-top: 0;
}
.character-image-uploader .el-upload {
  border: 1px dashed $--border-color-light;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.character-image-uploader .el-upload:hover {
  border-color: $--color-primary;
}
.character-image-uploader .character-image-uploader-icon {
  font-size: 28px;
  color: $text-extra-light-blue;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.character-image-uploader .selected-character-image {
  width: 178px;
  height: 178px;
  display: block;
  background: black;
}
#admin-variant-character-group-list .search-character-input {
  margin-right: 5px;
  width: 50px;
}

/**
 * delete dialog
 */
.delete-dialog .el-dialog__body {
  text-align: center;
}
.delete-dialog .delete-character-image-wrapper {
  margin-bottom: 10px;
}
.delete-dialog .delete-character-image {
  width: 150px;
  height: 150px;
  border-radius: 4px;
  background: black;
}
</style>
